<template>
  <div :class="$style['pt-goods-manage']">
    <pt-page-title title="商品管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      <el-button slot="before-left" type="primary" @click="created_goods" v-if="HAS_GOODS_MANAGEMENT">新建商品</el-button>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="filterCondition" isQueryRouter @Filter="Filter" ref="filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <!-- <el-button type="primary">导出</el-button> -->
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
    <pt-goods-manage-table :tableLabels="tableLabels" ref="goodsTable" :page-size="pageSize" :query-params="queryParams" :isFromRouter="isFromRouter">
      <template>
        <el-table-column label="推荐值">
          <template slot-scope="scope">
            <div :class="$style['ranking-div']" @mouseenter="editRanking(scope.row)" @mouseleave="noEditRank(scope.row)">
              {{scope.row.goodsOtherInfoDTO&&scope.row.goodsOtherInfoDTO.ranking}}
              <el-popover placement="bottom" trigger="click" v-if="scope.row.isEditRank" @mouseenter="editRanking(scope.row)">
                <edit-ranking :rowInfo="scope.row.goodsOtherInfoDTO" @sumitRank="sumitRank"></edit-ranking>
                <i class="iconfont icon-bianji" slot="reference" @click="editRinkValue(scope.row)"></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="首页展示">
          <template slot-scope="scope">
            <el-switch :value="scope.row.goodsOtherInfoDTO.recommend" @change="recommendChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="置顶">
          <template slot-scope="scope">
            <el-switch :value="scope.row.goodsOtherInfoDTO.sticky" @change="stickyChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="商品状态">
          <template slot-scope="scope">
            {{scope.row.goods_state}}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="scope">
            <div :class="$style['opreation-button']">
              <template v-if="HAS_GOODS_MANAGEMENT">
                <i class="iconfont icon-bianji" @click="editGoods(scope.row)"></i>
                <i class="iconfont icon-shanchu" v-if="!notDeleteRow(scope.row)" @click="deleteGoods(scope.row)"></i>
                <!-- <i class="iconfont icon-tuijian"
                            :class="[scope.row.goodsOtherInfoDTO&&scope.row.goodsOtherInfoDTO.recommend?'main-color':'']" @click="recommendGoods(scope.row)"></i> -->
                <el-button type="text" v-if="scope.row.goodsDTO.state=='DRAFT'" @click="submit(scope.row)">提交</el-button>
              </template>
              <el-button type="text" @click="goodsReview(scope.row)">预览</el-button>
              <el-button type="text" @click="goodsDetail(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
      </template>
    </pt-goods-manage-table>
    <review-goods-iframe :is-dialog="is_review" @closeDialog="closeDialog" :goods-id="review_id"></review-goods-iframe>
  </div>
</template>

<script>
// 组件class前缀
import { goodsTableLabels, filterFactor } from './goods-options.js'
import ptGoodsManageTable from './pt-goods-manage-table/withData.vue'
import editRanking from './edit-ranking'
import { hasPermissions } from 'utils/permissions'
import { emptyObject } from '@/utils/lifebankUtils'
import { cashCount } from '@/utils/formUtils'
import reviewGoodsIframe from './review-goods-iframe'
const PERM_MALL_GOODS_MANAGEMENT = 'PERM_MALL_GOODS_MANAGEMENT'// 商品管理权限
const prefixCls = 'pt-goods-manage'
export default {
  name: 'pt-goods-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      set: function (val) {
        this.is_review = val
      },
      get: function () {
        return this.is_review
      }
    }
  },
  components: {
    ptGoodsManageTable,
    editRanking,
    reviewGoodsIframe
  },
  props: {
    groupList: {
      type: Array,
      default: function () {
        return []
      }
    },
    goodsTypeList: {
      type: Array,
      default: function () {
        return []
      }
    },
    vendorsOrganizations: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      tableLabels: goodsTableLabels,
      filterLabels: filterFactor,
      filterCondition: {},
      selectMenu: '',
      row_now: {},
      queryParams: {
        sortWay: 'RECOMMEND_DESC'
      },
      pageSize: 10,
      is_review: false,
      dialog_title: '',
      review_id: '',
      HAS_GOODS_MANAGEMENT: hasPermissions(this.$auth.user() && this.$auth.user().permissions, PERM_MALL_GOODS_MANAGEMENT),
      showStockQuantity: false,
      tableLoading: false,
      searchKey: null,
      isFromRouter: false
    }
  },
  watch: {
    groupList: {
      handler: function (val) {
        this.filterLabelsOptions(val, 'groupId')
      },
      deep: true
    },
    goodsTypeList: {
      handler: function (val) {
        this.filterLabelsOptions(val, 'type')
      },
      deep: true
    },
    vendorsOrganizations: {
      handler: function (val) {
        this.filterLabelsOptions(val, 'vendorId')
      }
    }
  },
  methods: {
    // 获取筛选label的option
    filterLabelsOptions (val, name) {
      this.filterLabels.forEach(item => {
        if (item.value === name) {
          item.options = val
        }
      })
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      emptyObject(this.filterCondition)
      emptyObject(this.queryParams)
      this.queryParams.searchKey = val
    },
    emptySearch () {
      this.$delete(this.queryParams, 'searchKey')
    },
    // 已上架商品不能被删除
    notDeleteRow (val) {
      return val.goodsDTO && val.goodsDTO.state && val.goodsDTO.state === 'PUBLISHED'
    },
    recommendChange (val) {
      let text = val.goodsOtherInfoDTO.recommend ? '取消该商品的首页展示' : '将该商品展示在首页'
      this.$confirm('您是否确定' + text, '首页展示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('goodsRecommend', val)
      })
    },
    stickyChange (val) {
      let text = val.goodsOtherInfoDTO.sticky ? '取消置顶该商品' : '置顶该商品'
      this.$confirm('您是否确定' + text, '置顶', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        if (val.goodsOtherInfoDTO.sticky) {
          this.$emit('cancelStick', val)
        } else {
          this.$emit('setStick', val)
        }
      })
    },
    goodsDetail (val) {
    //   window.location.href = window.location.host + '/goods-manage/goods-detail/' + val.goodsDTO.id
      this.$router.push('/goods-manage/goods-detail/' + val.goodsDTO.id)
    },
    closeDialog () {
      this.is_review = false
    },
    goodsReview (val) {
      this.is_review = true
      this.review_id = val.goodsDTO.id
    },
    cleanParams () {
      emptyObject(this.filterCondition)
      this.Filter()
      this.queryParams = { ...{ sortWay: 'RECOMMEND_DESC' } }
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      if (!isFromRouter) {
        this.searchKey = null
        if (this.filterCondition.searchKey) {
          this.$delete(this.filterCondition, 'searchKey')
        }
      }
      for (var key in this.filterCondition) {
        if (!this.filterCondition[key]) {
          this.$delete(this.filterCondition, key)
        }
        if (key === 'priceInterval') {
          this.filterCondition.priceIntervalMax = cashCount(this.filterCondition[key].priceIntervalMax)
          this.filterCondition.priceIntervalMin = cashCount(this.filterCondition[key].priceIntervalMin)
          this.$delete(this.filterCondition, key)
        } else if (key === 'publishTime') {
          this.filterCondition = { ...this.filterCondition, ...this.filterCondition[key] }
          this.$delete(this.filterCondition, key)
        }
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.filterCondition)
      }
      this.queryParams = { ...{ sortWay: 'RECOMMEND_DESC' }, ...this.filterCondition }
      //   this.$route.query = { ...this.$route.query, ...this.queryParams }
    //   this.$set(this.queryParams, 'goodsData', JSON.parse(JSON.stringify(this.filterCondition)))
    },
    submit (val) {
      this.$confirm('您是否提交该商品', '提交', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('applyForApproval', val.goodsDTO.id)
      }).catch(_ => {

      })
    },
    goods_list () {
      let page = this.$refs.goodsTable.page
      this.$refs.goodsTable.getGoodsList(page)
    },
    created_goods () {
      this.$router.push('/goods-manage/goods-form/false/0')
    },
    editGoods (val) {
      this.$router.push('/goods-manage/goods-form/true/' + val.goodsDTO.id)
    },
    deleteGoods (val) {
      this.$confirm('您是否确定删除该商品', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning' }).then(_ => {
        this.$emit('goodsDelete', val.goodsDTO.id)
      }).catch(_ => {
      })
    },
    recommendGoods (val) {
      this.$emit('goodsRecommend', val)
    },
    editRanking (val) {
      this.$set(val, 'isEditRank', true)
      val.isEditRank = true
    },
    noEditRank (val) {
      if (!val.isedit) {
        this.$set(val, 'isEditRank', false)
      }
    },
    editRinkValue (val) {
      this.$set(val, 'isedit', true)
      this.$set(val, 'isEditRank', true)
      this.row_now = val
    },
    sumitRank () {
      this.$set(this.row_now, 'isEditRank', false)
      this.goods_list()
    },
    // 获取分组列表
    getGroupList () {
      this.$emit('getGoodsGroup')
    }
  },
  created () {
    // if (!this.$route.query || !isEmptyObject(this.$route.query)) { this.getQueryData() }
    if (!this.$store.getters.showStockQuantity) {
      this.tableLabels.forEach((item, index) => {
        if (item.label === '库存') {
          this.tableLabels.splice(index, 1)
        }
      })
    } else {
      this.showStockQuantity = this.$store.getters.showStockQuantity
    }
    this.getGroupList()
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.opreation-button{
    display: block;
    :global
    i{
        margin-right: 10px;
    }
}
.ranking-div{
    min-height: 23px
}
.edit-ranking-title{
    font-size: 15px;
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
}
.edit-ranking-button{
    margin-top: 20px;
    display: flex;
    justify-content: space-between
}
:global
.el-popper{

}
.pt-goods-manage{
:global
.goods-review-dialog{
    overflow: hidden;
    .el-dialog{
        margin-top: 3%!important;
        height: 94%;
        display: flex;
        width: 30%;
        min-width: 350PX;
        max-width: 400PX;
        flex-direction:column;
        .el-dialog__header{
            .el-dialog__title{
                width: 100%;
                text-align: center;
                display: block
            }
        }
        .el-dialog__body{
            border: 1px dashed #4A91FD;
            padding: 5px;
            flex: 1
        }
    }

}
}
.review-iframe{
    width: 100%;
    height: 100%;
}

</style>
